import { Textcomplete } from "@textcomplete/core";
import { TextareaEditor } from "@textcomplete/textarea";

export const MarkdownComplete = {
  mounted() {
    // Store textarea reference as a component property
    this.textarea = this.el.querySelector("textarea");

    // Initialize with empty suggestions array
    let allSuggestions = [];

    // Fetch all markdown suggestions from API
    fetch(
      `${appBasePath}/api/markdown-suggestions?language=${this.textarea.dataset.language}`
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.suggestions && Array.isArray(data.suggestions)) {
          // Update suggestions with all values from the server
          allSuggestions = data.suggestions;

          // If the dropdown is currently showing, refresh it with new suggestions
          if (this.textcomplete && this.textcomplete.dropdown.shown) {
            this.textcomplete.trigger(
              this.textarea.value,
              this.textarea.selectionStart
            );
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching markdown suggestions:", error);
      });

    // Add scroll event listener to hide dropdown when textarea is scrolled
    this.hideDropdown = () => {
      if (this.textcomplete && this.textcomplete.dropdown.shown) {
        this.textcomplete.dropdown.hide();
      }
    };
    this.textarea.addEventListener("scroll", this.hideDropdown);
    this.textarea.addEventListener("click", this.hideDropdown);

    const strategy = {
      match: /(?:^|\n)\s*\[([\-+\w:, ]*)$/,
      search: (term, callback) => {
        const lowerTerm = term.toLowerCase();

        // Split the term by colon to handle cases like 'Speaker: Phap Linh'
        const parts = lowerTerm.split(":");

        if (parts.length > 1) {
          // If there's a colon, we'll search for matches after the colon
          const prefix = parts[0].trim() + ":";
          const searchTerm = parts[1].trim();

          return callback(
            allSuggestions.filter((word) => {
              const lowerWord = word.toLowerCase();
              return (
                lowerWord.startsWith(prefix) && lowerWord.includes(searchTerm)
              );
            })
          );
        }

        // Default case: search anywhere in the text
        callback(
          allSuggestions.filter((w) => w.toLowerCase().includes(lowerTerm))
        );
      },
      replace: (word) => {
        // Check if there's already a closing bracket after the cursor
        const cursorPos = this.textarea.selectionEnd;
        const textAfterCursor = this.textarea.value.substring(cursorPos);
        const hasClosingBracket = textAfterCursor.match(/^\s*\]/);

        // If we already have a closing bracket, don't add another one
        return hasClosingBracket ? `\n\n[${word}` : `\n\n[${word}]`;
      },
    };

    const editor = new TextareaEditor(this.textarea);
    const textcomplete = new Textcomplete(editor, [strategy]);

    textcomplete.on("selected", () => {
      const value = this.textarea.value;
      const cursorPos = this.textarea.selectionStart;

      const dotsPos = value.lastIndexOf("...", cursorPos);
      const bracketPos = value.lastIndexOf("[", cursorPos);

      if (dotsPos !== -1 && bracketPos !== -1 && bracketPos < dotsPos) {
        this.textarea.setSelectionRange(dotsPos, dotsPos + 3);
      }
    });

    textcomplete.on("rendered", () => {
      if (textcomplete.dropdown.items.length > 0) {
        textcomplete.dropdown.show();
      } else {
        textcomplete.dropdown.hide();
      }
    });

    this.textcomplete = textcomplete; // for cleanup if needed
  },

  destroyed() {
    this.textarea.removeEventListener("scroll", this.hideDropdown);
    this.textarea.removeEventListener("click", this.hideDropdown);

    if (this.textcomplete) {
      this.textcomplete.destroy();
    }
  },
};
